import { EngagementTextarea } from '../EngagementTextarea'

import {
  ReplyFormCharCount,
  ReplyFormHeader,
  ReplyFormFooter,
  ReplyFormFooterEnd,
  ReplyFormFooterStart,
  ReplyFormRoot,
  ReplyFormSubmit,
} from './ReplyForm'

/**
 * The reply form every Community surface composes: comments, mentions and DM
 * messages each assemble the parts they show, so a change to a part reaches
 * all of them.
 *
 * ```tsx
 * <ReplyForm.Header>{timeLeftToReply}</ReplyForm.Header>
 * <ReplyForm.Root surface="card" ariaLabel="Write a message" onSubmit={send}>
 *   <ReplyForm.Field … />
 *   <ReplyForm.Footer>
 *     <ReplyForm.FooterStart>{emoji}{savedReplies}</ReplyForm.FooterStart>
 *     <ReplyForm.FooterEnd>
 *       <ReplyForm.Submit label="Send" disabled={!text} />
 *     </ReplyForm.FooterEnd>
 *   </ReplyForm.Footer>
 * </ReplyForm.Root>
 * ```
 */
export const ReplyForm = {
  Header: ReplyFormHeader,
  Root: ReplyFormRoot,
  Field: EngagementTextarea,
  Footer: ReplyFormFooter,
  FooterStart: ReplyFormFooterStart,
  FooterEnd: ReplyFormFooterEnd,
  CharCount: ReplyFormCharCount,
  Submit: ReplyFormSubmit,
}

export type { ReplyFormSurface } from './ReplyFormContext'
